export enum ApplicationComponent {
  App = 'app',

  Login = 'login',
}

export const DEFAULT_APPLICATION_COMPONENT = ApplicationComponent.App;